<span class="cmdk-row__icon cmdk-row__icon--brand" aria-hidden="true">
  <im-app-brand-icon
    [imageUrl]="link()?.customIcon"
    [svgPath]="link()?.catalogSvg"
    [fillRule]="link()?.catalogFillRule"
    [fallbackIcon]="link()?.icon || item().icon || 'globe'"
    [size]="20" />
</span>

<span class="cmdk-row__text">
  <span class="cmdk-row__title">{{ item().title }}</span>
  @if (item().subtitle) {
    <span class="cmdk-row__subtitle">{{ item().subtitle }}</span>
  }
</span>

@if (quickOpenKey(); as digit) {
  <paper-kbd class="cmdk-row__quick" [keys]="digit" [mod]="true" size="sm" />
} @else {
  <span class="cmdk-row__meta" aria-hidden="true">
    <paper-icon [name]="item().actionId ? 'arrow-right' : 'arrow-up-right'" [size]="14" />
  </span>
}
